import React from "react";

// Images
import juryPanelImg from "../images/jury-panel.png";
import mmipImg from "../images/miip-logo.png";
import vvipImg from "../images/vvip.jpeg";
// Jury Profile Picture
import jury1Img from "../images/jury/jury-img/jury1-img.png";
import jury2Img from "../images/jury/jury-img/jury2-img.png";
import jury3Img from "../images/jury/jury-img/jury3-img.png";
import jury4Img from "../images/jury/jury-img/jury4-img.png";
import jury5Img from "../images/jury/jury-img/jury5-img.png";
import jury6Img from "../images/jury/jury-img/jury6-img.png";
import jury7Img from "../images/jury/jury-img/jury7-img.png";
// Jury Info
import jury1InfoImg from "../images/jury/jury-info/jury1-info.png";
import jury2InfoImg from "../images/jury/jury-info/jury2-info.png";
import jury3InfoImg from "../images/jury/jury-info/jury3-info.png";
import jury4InfoImg from "../images/jury/jury-info/jury4-info.png";
import jury5InfoImg from "../images/jury/jury-info/jury5-info.png";
import jury6InfoImg from "../images/jury/jury-info/jury6-info.png";
import jury7InfoImg from "../images/jury/jury-info/jury7-info.png";

// Constant Data
const juries = [
  { img: jury1Img, info: jury1InfoImg, alt: "IDr Ooi Boon Seong" },
  { img: jury2Img, info: jury2InfoImg, alt: "Mr. Oliver Wee" },
  { img: jury3Img, info: jury3InfoImg, alt: "Ar Edric Choo Poo Liang" },
  { img: jury4Img, info: jury4InfoImg, alt: "Pn. Norliza Binti Abu Othman" },
  { img: jury5Img, info: jury5InfoImg, alt: "Mr. Liew Yong Kian" },
  { img: jury6Img, info: jury6InfoImg, alt: "En. Huszaini Bin Haron" },
  { img: jury7Img, info: jury7InfoImg, alt: "En. Kamarulzaman Kamarudin" },
];

function JuryList() {
  return (
    <div className="flex flex-col j-c-center a-i-center gap-15 m-b-25">
      <div className="text-center">
        <p className="font-bold m-b-5 text-gold">Organiser</p>
        <img className="full-width" src={mmipImg} alt="MMIP LOGO" />
      </div>
      <img className="full-width" src={vvipImg} alt="VVIP" />
      <img
        className="full-width m-t-30"
        src={juryPanelImg}
        alt="Awards Jury Panel"
      />
      {juries.map((el) => (
        <div
          className="grid a-i-center full-width gap-15"
          key={el.alt}
          style={{ gridTemplateColumns: "130px 180px" }}
        >
          <img className="full-width" src={el.img} alt={el.alt} />
          <img className="full-width" src={el.info} alt={el.alt} />
        </div>
      ))}
    </div>
  );
}

export default JuryList;
